<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2.938 5.242">
    <path data-name="Pfad 2106" d="M0 0v5.242l2.938-2.6Z" fill="#172124" />
  </svg>
</template>

<script>
export default {}
</script>
